var UserConstants = {
    USER_ADD_FORM: 'USER_ADD_FORM',
    USER_SETTINGS_FORM: 'USER_SETTINGS_FORM',
    USER_FORM_INVALID_SAVE: 'USER_FORM_INVALID_SAVE',
    USER_VALIDATION_ERROR: 'USER_VALIDATION_ERROR',

    USER_ADD: 'USER_ADD',
    USER_DELETE: 'USER_DELETE',
    USER_EDIT: 'USER_EDIT',
    USER_CHANGE_PASSWORD: 'USER_CHANGE_PASSWORD',
    USER_CHANGE_PASSWORD_SUCCESS: 'USER_CHANGE_PASSWORD_SUCCESS',
    BEGIN_EDIT_USER: 'BEGIN_EDIT_USER',
    BEGIN_USER_ADD: 'BEGIN_USER_ADD',
    FINISH_EDIT: 'FINISH_EDIT',
    UPDATE_MODAL_VISIBLE: 'UPDATE_MODAL_VISIBLE',
    USER_RECIEVE_DATA: 'USER_RECIEVE_DATA',
    USER_CHECK_NAME: 'USER_CHECK_NAME',
    USER_RECIEVE_HINT: 'USER_RECIEVE_HINT',
    USER_GET_ALL: 'USER_GET_ALL',
    USER_UPDATE_OBJECT: 'USER_UPDATE_OBJECT',
    USER_UPDATE_OBJECT_ADD_LIST: 'USER_UPDATE_OBJECT_ADD_LIST',
    USER_UPDATE_OBJECT_REMOVE_LIST: 'USER_UPDATE_OBJECT_REMOVE_LIST',
    USER_SELECT_HINT: 'USER_SELECT_HINT',
    USER_CURRENT_GET: 'USER_CURRENT_GET',
    USER_RECIEVE_CURRENT: 'USER_CURRENT_RECIEVE',
    USER_CURRENT_RECIEVE: 'USER_CURRENT_RECIEVE',
    RESET_LOGIN_ATTEMPTS: 'RESET_LOGIN_ATTEMPTS',

    SHOW_SETTINGS_MENU: 'SHOW_SETTINGS_MENU',
    HIDE_SETTINGS_MENU: 'HIDE_SETTINGS_MENU',
    SETTINGS_SAVE: 'SETTINGS_SAVE',
    SETTINGS_GET: 'SETTINGS_GET',
    SYSTEM_SETTING_GET: 'SYSTEM_SETTING_GET',
    SYSTEM_SETTING_SAVE: 'SYSTEM_SETTING_SAVE',
    SYSTEM_SETTINGS_GET: 'SYSTEM_SETTINGS_GET',
    SYSTEM_SETTINGS_SAVE: 'SYSTEM_SETTINGS_SAVE'
} as const;

export default UserConstants;
